// Orchestrates question selector + breakdown + charts for the Question sub-tab.

import React from "react";
import { Option, Select } from "@material-tailwind/react";
import { QuestionBreakdown } from "./question-breakdown";
import { QuestionCharts } from "./question-charts";

export function QuestionTab({
    perQuestionData,
    selectedQuestionId,
    setSelectedQuestionId,
    openChartTables,
    toggleChartTable,
    legendDirection,
    getLegendPosition,
    getBottomMargin,
    getBottomMarginNoLegend,
    getLegendItemWidth,
}) {
    const visible = selectedQuestionId !== undefined && perQuestionData?.length > 0;
    if (!visible) return null;

    const selectedQuestion = perQuestionData.find(
        (q) => q.number === Number(selectedQuestionId),
    );

    return (
        <>
            <div className="mb-2">
                <Select
                    label="Select Question to Display"
                    value={selectedQuestionId}
                    onChange={(value) => setSelectedQuestionId(value)}
                    className="bg-white"
                >
                    {perQuestionData.map((question) => (
                        <Option key={question.number} value={question.number.toString()}>
                            Q{question.number}: {question.text || "Untitled Question"}
                        </Option>
                    ))}
                </Select>
            </div>

            {selectedQuestion && (
                <div className="mb-8 border-b-2 pb-6">
                    <QuestionBreakdown qData={selectedQuestion} />
                    <QuestionCharts
                        qData={selectedQuestion}
                        openChartTables={openChartTables}
                        toggleChartTable={toggleChartTable}
                        legendDirection={legendDirection}
                        getLegendPosition={getLegendPosition}
                        getBottomMargin={getBottomMargin}
                        getBottomMarginNoLegend={getBottomMarginNoLegend}
                        getLegendItemWidth={getLegendItemWidth}
                    />
                </div>
            )}
        </>
    );
}
